import type { ReactNode } from "react"
import { btnLink, saleModifier } from "./button.css"
import { Link } from "@remix-run/react"

type Props = {
  url: string
  children: ReactNode
  shouldPrefetch?: boolean
  onClick?: () => void
  isSales?: boolean
  style?: Record<string, string>
}

function LinkButton({
  url,
  children,
  shouldPrefetch = false,
  onClick,
  isSales,
  style,
}: Props) {
  return (
    <Link
      to={url}
      className={`${btnLink} ${isSales ? saleModifier : ""}`}
      rel={shouldPrefetch ? "prefetch" : undefined}
      onClick={onClick}
      style={style}
    >
      {children}
    </Link>
  )
}

export default LinkButton
